import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { PawPrint } from "@phosphor-icons/react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { useApi, errMsg } from "../lib/api";

export const PET_SPECIES = ["Dog", "Cat", "Bird", "Rabbit", "Other"];
export const petGroups = (groups) => groups.filter((g) => ["family", "solo"].includes(g.type) && ["admin", "super"].includes(g.my_role));

export function AddPetDialog({ groups, testid = "add-pet-btn", variant = "outline" }) {
  const api = useApi();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", species: "Dog", group_id: groups[0]?.id });
  const create = async () => {
    try { const r = await api.post("/pets", f); toast.success(`${f.name} added`); setOpen(false); nav(`/app/profile/${r.data.id}`); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!groups.length) return null;
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><Button variant={variant} size="sm" data-testid={testid}><PawPrint size={16} className="mr-1" />Add pet</Button></DialogTrigger>
      <DialogContent className="bg-[#111a33]" data-testid="add-pet-dialog">
        <DialogHeader><DialogTitle>Add a pet</DialogTitle></DialogHeader>
        <Input data-testid="pet-name-input" placeholder="Pet's name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />
        <Select value={f.species} onValueChange={(v) => setF({ ...f, species: v })}><SelectTrigger data-testid="pet-species-select"><SelectValue /></SelectTrigger>
          <SelectContent>{PET_SPECIES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent></Select>
        {groups.length > 1 && <Select value={f.group_id} onValueChange={(v) => setF({ ...f, group_id: v })}><SelectTrigger data-testid="pet-group-select"><SelectValue /></SelectTrigger>
          <SelectContent>{groups.map((g) => <SelectItem key={g.id} value={g.id}>{g.name}</SelectItem>)}</SelectContent></Select>}
        <p className="text-xs text-slate-400">If someone scans your pet’s tag, they see the pet’s photo and your contact so they can call or WhatsApp you. Health and vet details stay private.</p>
        <Button data-testid="pet-create-btn" disabled={!f.name.trim()} onClick={create} className="bg-red-600 hover:bg-red-500 text-white">Add pet</Button>
      </DialogContent>
    </Dialog>
  );
}
